import React from "react";

import styled from "styled-components/macro";

import {
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";
import { motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import FnrUserPhoto from "UI/FnrUserPhoto";

export default function FundHeader({ setIntroIsComplete }) {
  const {
    state: {
      fund: { details, createdBy, fundColorSafe },
    },
  } = usePaymentPage();

  const { introButtonText } = useGetPaymentTypeVerbiage();

  const handleNextClick = () => {
    setIntroIsComplete(true);
  };

  return (
    <Wrapper>
      <Collapsible>
        <WrapperVerticalPadding />
        <ButtonWrapper>
          <FnrButton
            data-cy="introDonateButton"
            color={fundColorSafe}
            onClick={handleNextClick}
            fullWidth
            size="large"
          >
            {introButtonText}
          </FnrButton>
        </ButtonWrapper>

        <CreatedBy>
          Created By:
          <FnrUserPhoto
            url={createdBy?.photoURL}
            size={24}
            hideShadow={true}
            style={{ marginLeft: "8px", marginRight: "4px" }}
          />
          <span>{createdBy?.name}</span>
        </CreatedBy>

        {details && <Details dangerouslySetInnerHTML={{ __html: details }} />}

        <WrapperVerticalPadding />
        <IconsPreload>
          {/* These are needed so they're in cache in safari before it gets to the next screen.  Otherwise it's has to fetch them and looks delayed*/}
          <div className="fas fa-dollar-sign" />
          <div className="fas fa-user" />
          <div className="fas fa-credit-card" />
          $1234567890
        </IconsPreload>
      </Collapsible>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${sidePadding}
`;

const CreatedBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #767676;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 10px;
`;

const ButtonWrapper = styled.div`
  padding-bottom: 40px;
`;

const Details = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.7);
`;

const Collapsible = styled(motion.div)`
  height: auto;
`;

const IconsPreload = styled.div`
  position: absolute;
  opacity: 0;
  z-index: -1;
  user-select: none;
  font-family: Montserrat;
`;
